import React, { Component } from "react";
import { Row, Col, InputNumber, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import ButtonLinkIcon from "../../Components/MyComponent/ButtonLinkIcon";
import { API } from "../../API/API";
import { baseConfig } from "../../Config/Config";
class GetEmployees extends Component {
    state = {
        page: null,
        limit: 80,
    };
    save = () => {
        if (this.state.page != null || this.state.page != 0) {
            let body = {
                url: baseConfig.makurl,
                session_id: localStorage.getItem("access_token"),
                page: this.state.page,
                limit: this.state.limit
            }
            API.post("getEmpList", body).then((response) => {
                if (response.status === 200 && response.data.retType === 0) {
                    message.success("Амжилттай хадгаллаа.");
                }
            });
        }
        else {
            message.warning("Хуудсын тоо оруулна уу.");
        }
    };
    onChange = (value) => {
        this.setState({
            page: value
        });
    };
    onChangeLimit = (value) => {
        this.setState({
            limit: value
        });
    };
    render() {
        return (
            <div className="Container">
                <Row align="middle">
                    <Col span={24}>
                        <Row style={{ height: 56 }} justify="start" align="middle">
                            <Col>
                                <div className="HeaderLabel">ERP-аас ажилтан татах</div>
                            </Col>
                            <Col>
                                <div className="divider"></div>
                            </Col>
                        </Row>
                        <Row style={{ height: 56 }} justify="start" align="middle">
                            <Col>
                                <div className="fieldLabel">Хуудас:</div>
                            </Col>
                            <Col style={{ marginLeft: 5 }}>
                                <InputNumber
                                    align="right"
                                    defaultValue={this.state.page}
                                    onChange={this.onChange}
                                />
                            </Col>
                            <Col style={{ marginLeft: 15 }}>
                                <div className="fieldLabel">Хязгаар:</div>
                            </Col>
                            <Col style={{ marginLeft: 5 }}>
                                <InputNumber
                                    align="right"
                                    defaultValue={this.state.limit}
                                    onChange={this.onChangeLimit}
                                />
                            </Col>
                            <Col>
                                <ButtonLinkIcon
                                    onClick={() => this.save()}
                                    icon={<DownloadOutlined style={{ color: "#0358A7" }} />}
                                    name="Ажилтан татах"
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default withRouter(GetEmployees);
